import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, forkJoin, map, Observable, tap } from 'rxjs';
import { ValueList_create, ValueList_delete, ValueList_GetFilteredKeyValueDictionaryByCode, ValueList_readAll, ValueList_readById, ValueList_ReadKeyValueDictionaryByCode, ValueList_update, ValueListItem_create, ValueListItem_delete, ValueListItem_readByTenantId, ValueListItem_readById, ValueListItem_readByValueListId, ValueListItem_readByVlCode, ValueListItem_readByVlCodeList, ValueListItem_update } from 'src/app/GlobalVariables';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import { UserLoginService } from '../UserLoginService/userlogin.service';
import { FilteredKeyValueRequestDTO, KeyValueDictionaryList, KeyValueRequestDTO, ValueListCreateRequestDTO, ValueListDeleteRequestDTO, ValueListDTO, ValueListList, ValueListReadByIdRequestDTO, ValueListUpdateRequestDTO } from './valuelist.interface';
import { ValueListItemCreateRequestDTO, ValueListItemDeleteRequestDTO, ValueListItemDTO, ValueListItemList, ValueListItemReadByTenantId, ValueListItemReadByIdRequestDTO, ValueListItemReadByValueListIdRequestDTO, ValueListItemReadByVlCodeListRequestDTO, ValueListItemReadByVlCodeRequestDTO, ValueListItemUpdateRequestDTO } from './ValueListItem.interface';
import { GetDictionaryList } from '../common.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})


export class ValueListService {

  constructor(private UserLoginService: UserLoginService) {


  }


  http = inject(HttpClient);
  ValueList$ = new BehaviorSubject<ValueListDTO[]>([]);
  ValueListItems$ = new BehaviorSubject<ValueListItemDTO[]>([]);



  User = this.UserLoginService.User()

  FetchAllValueLists() {
    this.User = this.UserLoginService.User()

    forkJoin({
      valueList: this.ValueList_readAll(),
      valueListItems: this.ValueListItem_readByTenantId({ tenantId: this.User.companyId, tenantBranchId: this.User.loggedInBranchId })
    }).subscribe(({ valueList, valueListItems }) => {
      this.ValueList$.next(valueList.items)
      this.ValueListItems$.next(valueListItems.items)
    });
  }

  getItemByVLCode(vlCode: string): Observable<{ valueListItems: ValueListItemDTO[]; ValueList: ValueListDTO | undefined; }> {
    return combineLatest([this.ValueList$, this.ValueListItems$]).pipe(
      map(([valueLists, valueListItems]) => {
        const valuelist = valueLists.find(i => i.vlCode === vlCode);
        return {
          valueListItems: valueListItems.filter(f => f.valueListId === valuelist?.valueListId),
          ValueList: valuelist
        };
      })
    );
  }





  ValueList_create(data: ValueListCreateRequestDTO): Observable<ValueListDTO> {
    return this.http.post<ValueListDTO>(ValueList_create, data).pipe(tap((newValueList: ValueListDTO) => {
      const current = this.ValueList$.getValue();
      this.ValueList$.next([...current, newValueList]);
    }))
  }
  ValueList_update(data: ValueListUpdateRequestDTO): Observable<ValueListDTO> {
    return this.http.post<ValueListDTO>(ValueList_update, data).pipe(tap((updatedValueList: ValueListDTO) => {
      const current = this.ValueList$.getValue();
      const updatedList = current.map(item =>
        item.valueListId === updatedValueList.valueListId ? updatedValueList : item
      );
      this.ValueList$.next(updatedList);
    }))
  }
  ValueList_delete(data: ValueListDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ValueList_delete, data).pipe(
      tap(() => {
        const current = this.ValueList$.getValue();
        const updatedList = current.filter(item => item.valueListId !== data.valueListId);
        this.ValueList$.next(updatedList);
      })
    );
  }
  ValueList_readById(data: ValueListReadByIdRequestDTO): Observable<ValueListDTO> {
    return this.http.post<ValueListDTO>(ValueList_readById, data)
  }
  ValueList_readAll(): Observable<ValueListList> {
    return this.http.get<ValueListList>(ValueList_readAll)
  }

  ValueList_readKeyValueDictionaryByCode(data: KeyValueRequestDTO): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(ValueList_ReadKeyValueDictionaryByCode, data)
  }





  ValueListItem_create(data: ValueListItemCreateRequestDTO): Observable<ValueListItemDTO> {
    return this.http.post<ValueListItemDTO>(ValueListItem_create, data).pipe(tap((newValueListItem: ValueListItemDTO) => {
      const current = this.ValueListItems$.getValue();
      this.ValueListItems$.next([...current, newValueListItem]);
    }))
  }


  ValueListItem_update(data: ValueListItemUpdateRequestDTO): Observable<ValueListItemDTO> {
    return this.http.post<ValueListItemDTO>(ValueListItem_update, data).pipe(tap((updatedValueListItem: ValueListItemDTO) => {
      const current = this.ValueListItems$.getValue();
      const updatedList = current.map(item =>
        item.valueListItemId === updatedValueListItem.valueListItemId ? updatedValueListItem : item
      );
      this.ValueListItems$.next(updatedList);
    }))
  }

  ValueListItem_delete(data: ValueListItemDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ValueListItem_delete, data).pipe(tap(() => {
      const current = this.ValueListItems$.getValue();
      const updatedList = current.filter(item => item.valueListItemId !== data.valueListItemId);
      this.ValueListItems$.next(updatedList);
    }))
  }

  ValueListItem_readById(data: ValueListItemReadByIdRequestDTO): Observable<ValueListItemDTO> {
    return this.http.post<ValueListItemDTO>(ValueListItem_readById, data)
  }

  // baseUrlOverride/companyId/branchId (all optional): the viewed tenant's
  // own AM gateway origin (Value List tab, double-click on a Value List row -
  // see valuelist.component.ts's filterItemsByValueList). Omitted for every
  // other caller - behaves exactly as before.
  ValueListItem_readByValueListId(data: ValueListItemReadByValueListIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(resolveTenantUrl(ValueListItem_readByValueListId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }

  ValueListItem_readByVlCode(data: ValueListItemReadByVlCodeRequestDTO): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(ValueListItem_readByVlCode, data)
  }

  ValueListItem_readByVlCodeListId(data: ValueListItemReadByVlCodeListRequestDTO): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(ValueListItem_readByVlCodeList, data)
  }

  // baseUrlOverride/companyId/branchId (all optional): the viewed tenant's
  // own AM gateway origin, e.g. CompanyDetailComponent.apiConfigOverride.am
  // (Value List tab). Omitted for every other caller (e.g.
  // FetchAllValueLists(), which reads for the ADMIN's OWN tenant) - behaves
  // exactly as before.
  ValueListItem_readByTenantId(data: ValueListItemReadByTenantId, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(resolveTenantUrl(ValueListItem_readByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }

  ValueListItem_ReadKeyValueDictionaryByCode(data: KeyValueRequestDTO): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(ValueList_ReadKeyValueDictionaryByCode, data)
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-subroles tab).
  // Omitted for every other caller - behaves exactly as before.
  ValueListItem_GetFilteredKeyValueDictionaryByCode(data: FilteredKeyValueRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(resolveTenantUrl(ValueList_GetFilteredKeyValueDictionaryByCode, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }


  // Hardcoded to AdvinPROD01 rather than built from environment.AMBaseURL:
  // this is the host -> tenantId bootstrap call, made before any tenant is
  // known, so it must always reach the server hosting the
  // [UseIdentityServer] endpoints regardless of which tenant/pool this
  // browser ultimately resolves to.
  ValueListItem_GetFilteredKeyValueExtendedByCode(data: FilteredKeyValueRequestDTO): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(environment.ValueListAPI, data)
  }
}
